import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-252d9928"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-auto the-app-header__tools border--left border--grey-2 mr-0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-notifications the-app-header__tools__profile-chevron" }, null, -1))
const _hoisted_3 = {
  key: 0,
  id: "notifications-iframe",
  class: "notifications__iframe",
  src: "https://account.mitrefinchdev.co.uk/Notification"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!

  return false
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createVNode(_component_Btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isNotificationsDisplayed = true)),
          id: "notifications-bell-button",
          title: "View notifications",
          ghost: ""
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        (_ctx.isNotificationsDisplayed)
          ? (_openBlock(), _createElementBlock("iframe", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}